export const status = {
    STATUS_UNDEFINED: 'UNDEFINED',
    STATUS_ACTIVATED: 'ACTIVATED',
    STATUS_SUSPENDED: 'SUSPENDED',
    STATUS_CANCELED: 'CANCELED',
    STATUS_OVERDUE: 'OVERDUE',
};

export const statusDescription = {
    'UNDEFINED': 'indefinida',
    'ACTIVATED': 'ativada',
    'SUSPENDED': 'suspensa',
    'CANCELED': 'cancelada',
    'OVERDUE': 'atrasada',
};

export const badgeColor = {
    'grey': 'secondary',
    'green': 'success',
    'yellow': 'warning',
    'red': 'danger',
};